import React from 'react';
import './SuggestionsSection.scss';

const SuggestionsSection = ({ suggestions, translation, originUrlRedirection }) => {
    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div className="interesting">
            <h4 className="title">
                {translation('interestedIn')}
            </h4>
            {suggestions.map((suggestion, index) => (
                <div key={index}>
                    <a
                        href={suggestion.url}
                        className="content"
                    >
                        {suggestion.description}
                    </a>
                </div>
            ))}
        </div>
    );
};

export default SuggestionsSection;
